import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 104.7 36.98"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M85 32.1c-8.7.4-16.3-2.9-12.1-11.2C77.1 12.6 97.9 3 104.7 0H66.5c-1.3 0-2.9-.2-3.9 2.8-.7 2.2-4.2 10.8-11.8 13.4-9.4 3.3-17.3-2.1-29.3-11.6C17 1.1 16.3.7 12 1.4 9.8 1.8 5 .6 3.6.3 2.2-.1 0 .1 0 .1c0 .2 8.7 1.4 25.5 13.4 6.4 4.6 17.8 13.5 29.6 18.6 12.8 5.6 31.4 8.5 48.4-3.3l.1-.7c-.2.2-10 3.7-18.6 4",
      style: {"fill":"#008bce"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MF-logo"}) } }